import { makeStyles } from '@material-ui/core/styles'
import InfoIcon from '@mui/icons-material/Info'
import { Card, CardContent } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  cardContent: {
    '&:last-child': {
      paddingBottom: '16px',
    },
  },
  iconSection: {
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
  },
  marginTop: '20px',
}))

const Alert = ({ children, color = 'primary', colorIcon, isMarign }) => {
  const classes = useStyles()
  return (
    <Card
      className={classes.root}
      style={{
        marginTop: isMarign ? '160px' : '',
        // background: color ? color : "rgb(222, 243, 255)",
        background: '#ededed',
      }}
    >
      <CardContent
        className={classes.iconSection}
        style={{ background: '#e0e0e0' }}
      >
        <InfoIcon
          style={{ color: '#143a5f' }}
          // style={{ color: colorIcon ? colorIcon : "#143a5f" }}
          className={classes.icon}
        />
      </CardContent>
      <CardContent className={classes.cardContent}>{children}</CardContent>
    </Card>
  )
}

export default Alert
